module.exports = __webpack_public_path__ + "media/images/business/bg-circle-958e08df648ff604cf6af335d0176e19.svg";